export const environment = {
  apiUrl: "https://froc.pontobiometrico.com.br/api/app",
  production: false
};
